<template slot-scope="scope">
  <div>
    <div>
      <el-form ref="form" :model="form" label-width="80px">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="title"></span>
            <span style="float: left;">基本信息：</span>
          </div>
          <el-form ref="formOne" size="mini" :model="form" label-width="150px" :disabled="type">
            <el-form-item label="查新机构：" prop="mechanism">
              <el-select v-model="form.mechanism" placeholder="请选择查新机构" style="width: 100%">
                <el-option label="中科院上海分院" value="中科院上海分院" />
                <el-option label="上海浦东智产" value="上海浦东智产" />
              </el-select>
            </el-form-item>
            <el-form-item label="项目名称：" prop="projectName">
              <el-input v-model="form.projectName" placeholder="请输入项目名称"></el-input>
            </el-form-item>
            <el-form-item label="英文名称：" prop="projectEnglishName">
              <el-input v-model="form.projectEnglishName" placeholder="请输入英文名称"></el-input>
            </el-form-item>
            <el-form-item label="期望完成日期：" prop="expectedCompletionDate">
              <el-date-picker
                v-model="form.expectedCompletionDate"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="float: left;"
                type="datetime"
                placeholder="选择期望完成日期"
              />
            </el-form-item>
            <el-form-item label="查新范围：" prop="scope">
              <el-checkbox-group style="float: left;" v-model="form.scope">
                <el-checkbox v-for="city in cityOptions" :label="city.value" :key="city.value">
                  {{ city.label }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="查新目的：" prop="purpose">
              <el-checkbox-group style="float: left;" v-model="form.purpose">
                <el-checkbox v-for="city in checkedCities" :label="city.value" :key="city.value">
                  {{ city.label }}
                </el-checkbox>
              </el-checkbox-group>
              <el-input
                v-model="form.purposeDetails"
                v-if="form.purposeDetails"
                placeholder="请输入其他查新目的"
                type="textarea"
                :rows="2"
              />
            </el-form-item>
          </el-form>
        </el-card>
        <el-card class="box-card" style="margin-top: 0;" shadow="never">
          <div slot="header" class="clearfix">
            <span class="title"></span>
            <span style="float: left;">委托人：</span>
          </div>
          <el-form
            ref="formTwo"
            :inline="true"
            size="mini"
            :model="form"
            label-width="150px"
            :disabled="type"
          >
            <el-form-item label="单位名称：" prop="clientUnitName" style="float: left;">
              <el-input
                style="width: 700px;"
                v-model="form.clientUnitName"
                placeholder="请输入单位名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系人：" prop="clientContact" style="float: left;">
              <el-input
                v-model="form.clientContact"
                style="width: 270px;"
                placeholder="请输入联系人"
              />
            </el-form-item>
            <el-form-item label="联系电话：" prop="clientPhone" style="float: left;">
              <el-input
                v-model="form.clientPhone"
                style="width: 270px;"
                placeholder="请输入联系电话"
              />
            </el-form-item>
            <el-form-item label="通信地址：" prop="clientMailingAddress" style="float: left;">
              <el-input
                v-model="form.clientMailingAddress"
                style="width: 270px;"
                placeholder="请输入通信地址"
              />
            </el-form-item>
            <el-form-item label="电子邮箱：" prop="clientEmail" style="float: left;">
              <el-input
                v-model="form.clientEmail"
                style="width: 270px;"
                placeholder="请输入电子邮箱"
              />
            </el-form-item>
          </el-form>
        </el-card>
        <el-card class="box-card" style="margin-top: 0;" shadow="never">
          <div slot="header" class="clearfix">
            <span class="title"></span>
            <span style="float: left;">收件信息：</span>
          </div>
          <el-form
            ref="formThree"
            :inline="true"
            size="mini"
            :model="form"
            label-width="150px"
            :disabled="type"
          >
            <el-form-item label="收件地址：" prop="shippingAddress" style="float: left;">
              <el-input
                style="width: 700px;"
                v-model="form.shippingAddress"
                placeholder="请输入收件地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="收件人：" prop="shippingContact" style="float: left;">
              <el-input
                v-model="form.shippingContact"
                style="width: 270px;"
                placeholder="请输入收件人"
              />
            </el-form-item>
            <el-form-item label="电话：" prop="shippingPhone" style="float: left;">
              <el-input
                v-model="form.shippingPhone"
                style="width: 270px;"
                placeholder="请输入电话"
              />
            </el-form-item>
            <el-form-item label="发票类型：" prop="invoiceType" style="float: left;">
              <el-select
                v-model="form.invoiceType"
                placeholder="请选择发票类型"
                style="width: 270px"
              >
                <el-option label="不开票" :value="0" />
                <el-option label="增值税普通电子发票" :value="1" />
                <el-option label="增值税专用电子发票" :value="2" />
              </el-select>
            </el-form-item>
          </el-form>
        </el-card>
        <el-card class="box-card" style="margin: 10px 0;" shadow="never">
          <div slot="header" class="clearfix">
            <span class="title"></span>
            <span style="float: left;">查新项目的科学技术要点简述：</span>
          </div>
          <el-form ref="formShree" size="mini" :model="form" :disabled="type">
            <div style="text-align: left;font-size: 12px;color: #a3a3a3;">
              <span style="color: red;">*</span>
              1.简述项目所述科学技术领域及要解决的技术问题
            </div>
            <el-form-item prop="briefDescription">
              <el-input v-model="form.briefDescription" type="textarea" :rows="2"></el-input>
            </el-form-item>
            <div style="text-align: left;font-size: 12px;color: #a3a3a3;">
              <span style="color: red;">*</span>
              2.重点描述项目为解决技术问题所采用的技术方案，如材料、工艺、方法、设备等方面的创新
            </div>
            <el-form-item prop="keyDescription">
              <el-input v-model="form.keyDescription" type="textarea" :rows="2"></el-input>
            </el-form-item>
            <div style="text-align: left;font-size: 12px;color: #a3a3a3;">
              <span style="color: red;">*</span>
              3.有益效果，可以有产率、质鱼、精度和效率的提高，能耗、原材料、工序的节省，加工、探作、控制、使用的简便，环境污染的治理或者根除，以及有用性能的出现等方面反映出来
            </div>
            <el-form-item prop="beneficialEffects">
              <el-input v-model="form.beneficialEffects" type="textarea" :rows="2"></el-input>
            </el-form-item>
            <div style="text-align: left;font-size: 12px;color: #a3a3a3;">
              <span style="color: red;">*</span>
              4．查新点（主要反映项目的技术方案和技术效果，应以通用，规范的技术术语进行表述，不得使用带有修饰性的表述语，如打破，首创、独特等，凡需要查证的数据，指标等还应提供权威机构的检测报告，如有多个查新点，应逐条列出，每个蛮新
              点突出一个技术主题或技术特征，一般不超过3点）
            </div>
            <el-form-item prop="checkNewPoints">
              <el-input v-model="form.checkNewPoints" type="textarea" :rows="2"></el-input>
            </el-form-item>
          </el-form>
        </el-card>
        <el-card class="box-card" style="margin: 10px 0;" shadow="never">
          <div slot="header" class="clearfix">
            <span class="title"></span>
            <div style="text-align: left;">委托人提供的资料(如果有请提交到附件)</div>
            <div style="text-align: left;font-size: 12px;color: #a3a3a3;">
              1.若需要出具查新咨询(查新+水平)报告:用户必需提供检测报告或用户报告;
              <br />
              2.委托方拥有与本项目密切相关的专利、文献发麦情况;
              <br />
              3.项目知识产权若引进、购买或者共有，列出清单说明;
              <br />
              4.背景参考文献。
            </div>
          </div>
          <div slot="header" class="clearfix" style="margin: 20px 0;">
            <span class="title"></span>
            <div style="text-align: left;">委托人提供的资料(如果有请提交到附件)</div>
            <div style="text-align: left;font-size: 12px;color: #a3a3a3;">
              提供公认的技术术语，包括关键词、规花词、同义词、近义词、维写、全称;必要的化学物质名称、CAS登记号、分子式及结构;物种拉丁文名称;专利分类号等，国外查新还蛋要提供英文检染词和查新项目的英文名称
            </div>
            <div style="display: flex;justify-content: space-between;"></div>
            <div style="width: 49%;">
              <div style="text-align: left;">中文</div>
              <el-input
                v-model="form.cnSearchTerms"
                type="textarea"
                :disabled="type"
                :rows="2"
                placeholder="请输入内容"
              />
            </div>
            <div style="width: 2%;"></div>
            <div style="width: 49%;">
              <div style="text-align: left;">英文</div>
              <el-input
                v-model="form.enSearchTerms"
                type="textarea"
                :disabled="type"
                :rows="2"
                placeholder="请输入内容"
              />
            </div>
          </div>
          <div slot="header" class="clearfix" style="position: relative;">
            <span class="title"></span>
            <div style="text-align: left;">附件</div>
            <el-button @click="fj()" style="position: absolute;top: 20px;left: 0;">
              下载附件
            </el-button>
          </div>
          <div slot="header" class="clearfix">
            <span class="titles"></span>
            <div style="text-align: left; margin-top: 60px">其他</div>
            <el-input
              v-model="form.otherInfo"
              :disabled="type"
              type="textarea"
              :rows="3"
            ></el-input>
          </div>
          <div style="text-align: left;margin-top:10px">{{ form.fileUrl }}</div>
        </el-card>
        <el-card class="box-card" style="margin: 10px 0;" shadow="never" v-if="active">
          <div slot="header" class="clearfix">
            <span style="float: left;">审核信息：</span>
          </div>
          <el-form ref="dialogForm" size="mini" :model="reviewForm" :rules="rules">
            <el-form-item prop="approvalStatus" label="审核状态：">
              <div style="text-align: left;">
                <el-select
                  v-model="reviewForm.approvalStatus"
                  :disabled="type || form.status === 4"
                >
                  <el-option label="不通过" :value="2" />
                  <!-- <el-option label="退回" :value="0" /> -->
                  <el-option label="通过" :value="6" />
                </el-select>
              </div>
            </el-form-item>
            <el-form-item prop="auditOpinion" label="审核意见：">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入内容"
                v-model="reviewForm.auditOpinion"
                :disabled="type || form.status === 4"
              ></el-input>
            </el-form-item>
            <el-form-item prop="fileList" label="初级查新报告：">
              <el-upload
                v-if="!type"
                :disabled="type || form.status === 4"
                class="upload-demo"
                :action="this.uploadURL"
                style="text-align: left"
                :on-success="
                  (response, file, fileList) =>
                    handleAvatarSuccess(response, file, fileList, 'file','fileList')
                "
                accept=".pdf,.docx,.doc,.xlsx,.xls"
                :limit="1"
                :on-remove="handleRemove"
              >
                <el-button size="small" type="primary" :disabled="type">上传</el-button>
              </el-upload>
              <el-button v-else size="small" type="primary" @click="fjDown()" style="float: left">
                下载初级查新报告
              </el-button>
            </el-form-item>
            <div style="text-align: left;margin-top:10px" v-if="(type || form.status === 4) && reviewForm.fileList">
              {{ reviewForm.fileList }}
            </div>

            <el-form-item prop="fileList" label="终级查新报告：">
              <el-upload
                v-if="!type"
                :disabled="type"
                class="upload-demo"
                :action="this.uploadURL"
                style="text-align: left"
                :on-success="
                  (response, file, fileList) =>
                    handleAvatarSuccess(response, file, fileList, 'file','finalFileUrl')
                "
                accept=".pdf,.docx,.doc,.xlsx,.xls"
                :limit="1"
                :on-remove="handleRemove('finalFileUrl')"
              >
                <el-button size="small" type="primary" :disabled="type">上传</el-button>
              </el-upload>
              <el-button v-else size="small" type="primary" @click="fjDown()" style="float: left">
                下载终级查新报告
              </el-button>
            </el-form-item>
            <div style="text-align: left;margin-top:10px" v-if="type && form.finalFileUrl">
              {{ form.finalFileUrl }}
            </div>
          </el-form>
        </el-card>
        <el-button type="primary" @click="submitForm(form)" v-if="form.status == 1 || form.status == 4">确认</el-button>
        <el-button @click="deleteForm">{{ form.status == 1 ? "取消" : "关闭" }}</el-button>
      </el-form>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
export default {
  props: {
    form: {
      type: Object,
      required: true,
    },
    type: {
      type: Boolean,
    },
  },
  data() {
    return {
      active: true,
      reviewForm: {
        approvalStatus: "",
        auditOpinion: "",
        fileList: "",
        creatorName: JSON.parse(this.$store.getters.userInfo).username,
      },
      cityOptions: [
        {
          label: "国内",
          value: 1,
        },
        {
          label: "国内外",
          value: 2,
        },
        {
          label: "水平",
          value: 3,
        },
      ],
      checkedCities: [
        {
          label: "立项查新",
          value: 1,
        },
        {
          label: "成果查新",
          value: 2,
        },
        {
          label: "产品查新",
          value: 3,
        },
        {
          label: "工法查新",
          value: 4,
        },
        {
          label: "其他",
          value: 5,
        },
      ],
      rules: {
        approvalStatus: [{ required: true, message: "请输入内容", trigger: "blur" }],
        auditOpinion: [{ required: true, message: "请输入内容", trigger: "blur" }],
      },
    };
  },
  methods: {
    //下载附件
    fjDown() {
      if (!this.reviewForm.fileList) {
        return this.$message({
          message: "暂无报告",
          type: "warning",
        });
      }
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = "https://devfile.gsisc.cn/" + this.reviewForm.fileList;
      document.body.appendChild(link);
      //将上面创建的a标签加入到body的尾部
      link.click();
    },
    //审核信息详情
    getData(row, type) {
      this.reviewForm = { ...row };
      this.active = type;
    },
    //上传文件事件
    handleAvatarSuccess(response, file, fileList, type,str) {
      this.reviewForm[str] = response.data.store_result;
    },
    handleRemove(str='finalFileUrl') {
      this.reviewForm[str] = "";
    },
    deleteForm() {
      this.$emit("submitForm");
      this.this.$refs.dialogForm.resetFields();
    },
    submitForm(val) {
      if (this.reviewForm.approvalStatus === 6 && !this.reviewForm.fileList) {
        return this.$message({
          message: "暂无报告",
          type: "warning",
        });
      }
      let params = {
        ...this.form,
        scope: this.form.scope.join(","),
        purpose: this.form.purpose.join(","),
        technologyNoveltySearchId: val.id,
        ...this.reviewForm,
        creator: Cookies.get("userId"),
        updater: Cookies.get("userId"),
      };
      this.$refs.dialogForm.validate(valid => {
        if (valid) {
          let url = `${this.urlConfig.devUrl}apij2/admin-api/voucher/technology-novelty-search-record/approvalNew`;
          this.http.post(url, params).then(res => {
            if (res.data) {
              if(this.form.status !== 4){

              this.$message({
                message: "审核成功",
                type: "success",
              });
              }
              this.$emit("submitForm");
              this.this.$refs.dialogForm.resetFields();
            }
          });
        } else {
          this.$message({
            message: "请检查表单内容",
            type: "warning",
          });
        }
      });
    },
    fj() {
      if (this.form.fileUrl) {
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = "https://devfile.gsisc.cn/" + this.form.fileUrl;
        document.body.appendChild(link);
        //将上面创建的a标签加入到body的尾部
        link.click();
      } else {
        this.$message.error("暂无附件！");
      }
    },
  },
};
</script>
<style>
.el-card__header {
  border-bottom: 0 !important;
}

.upload-demo {
  border: 0 !important;
}
.el-card {
  border: 0 !important;
}
</style>
